import { PiggyResourcePackage } from "../../resources/PiggyResourcePackage";
import { IPiggyController } from "../../controller/IPiggyController";
import { PiggyInfoComponent } from "../piggyinfo/PiggyInfoComponent";
import { PiggyInfoNextPiggyComponent } from "../piggyinfo/PiggyInfoNextPiggyComponent";
import { PiggyContentView } from "./PiggyContentView";
import { IDestroyOptions, Point } from "pixi.js";
import { ICanvasScaler } from "by/gamefactory/canvas/ICanvasScaler";
import { gsap } from "gsap";

export class NextPiggyContentView extends PiggyContentView {
    private static readonly MOVE_DURATION = 0.6;
    private static readonly HIDE_DURATION = 0.6;

    private readonly moveAnimation: gsap.core.Timeline;
    private readonly canvasScaler: ICanvasScaler;
    private readonly moveDistanceOffsetX: number;

    private piggyInfo: PiggyInfoComponent;

    public constructor(
        piggyResources: PiggyResourcePackage,
        piggyController: IPiggyController,
        canvasScaler: ICanvasScaler,
        moveDistanceOffsetX: number
    ) {
        super(piggyResources, piggyController, piggyResources.assets_views_piggy_black_piggy_png, new Point(364, 420));
        this.canvasScaler = canvasScaler;
        this.moveDistanceOffsetX = moveDistanceOffsetX;
        this.moveAnimation = new gsap.core.Timeline({ paused: true });
        this.build();
        this.layout();
        this.initMoveAnimation();
    }

    private build(): void {
        this.piggyInfo = new PiggyInfoNextPiggyComponent(this.piggyResources);
        this.piggyInfo.pivot.set(this.piggyInfo.width * 0.5, this.piggyInfo.height * 0.5);
        this.addChild(this.piggyInfo);
    }

    private layout(): void {
        this.piggyInfo.position.set(100 + this.piggyInfo.width * 0.5, 1149 + this.piggyInfo.height * 0.5);
    }

    private initMoveAnimation(): void {
        const duration = NextPiggyContentView.MOVE_DURATION;
        const distance = this.canvasScaler.referenceWidth + this.moveDistanceOffsetX;
        this.moveAnimation.to(this.bigPiggy, { x: -distance * 1.28, duration: duration, ease: "power1.onOut" });
        this.moveAnimation.to(this.piggyInfo, { x: this.piggyInfo.position.x - distance, duration: duration, ease: "power1.onOut" }, "<");
    }

    public async playMoveLeftAnimation(): Promise<void> {
        await this.moveAnimation.play();
    }

    public async playMoveRightAnimation(): Promise<void> {
        await this.moveAnimation.reverse();
    }

    public async playHideAnimation(): Promise<void> {
        const duration = NextPiggyContentView.HIDE_DURATION;
        const timeline = new gsap.core.Timeline({ paused: true });
        timeline.to(this.bigPiggy, { x: this.bigPiggy.position.x - this.bigPiggy.width, y: this.bigPiggy.position.y + 50, angle: -10, duration: duration, ease: "power1.in" }, "<");
        timeline.to(this.piggyInfo, { y: this.canvasScaler.referenceHeight, angle: -40, duration: duration, ease: "power1.in" }, "<");
        timeline.fromTo(this.piggyInfo.scale, { x: this.piggyInfo.scale.x, y: this.piggyInfo.scale.y }, { x: 0, y: 0, duration: duration, ease: "power1.in" }, "<");
        await timeline.play();
        timeline.kill();
    }

    public override destroy(options?: boolean | IDestroyOptions): void {
        this.moveAnimation.kill();
        super.destroy(options);
    }
}
